'use client'

import { Container } from '@/shared/components/Container'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleArrowRight } from '@fortawesome/pro-regular-svg-icons'
import Image from 'next/image'
import landingPageHero from '@/images/hero/home.png'
import { faStar } from '@fortawesome/sharp-solid-svg-icons'
import React, { useRef, useState } from 'react'
import useInterval from '@/shared/hooks/useInterval'
import { motion } from 'framer-motion'
import ProductReviewVariant2 from '@/shared/components/common/product-review-variant-2'

const textBlocks = [
  ['Instant E-Scripts', 'text-[#2563EB]'],
  ['Instant Certificates', 'text-[#B7804A]'],
  ['Instant Medication', 'text-[#00A76E]'],
  ['Instant Referrals', 'text-[#5C8CB5]'],
  ['Instant Consultation', 'text-[#CF9358]'],
  ['Instant ED Meds', 'text-[#AC7758]'],
]

export default function InstantScriptRevealHero() {
  const [currentCopyIdx, setCurrentCopyIdx] = useState(0)
  const blocksToAnimate = [...textBlocks, textBlocks[0]]
  const header = useRef<HTMLHeadingElement>(null)
  const height = header.current?.clientHeight
  const [first, setFirst] = useState(false)

  useInterval(
    () => {
      let next = currentCopyIdx + 1
      if (next >= blocksToAnimate.length) next = 0

      setCurrentCopyIdx(next)
      setFirst(true)
    },
    currentCopyIdx === 0 && first ? 10 : 1600,
  )

  return (
    <Container className="mb-16 mt-32 sm:mb-32">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="col-span-1 space-y-6 self-center">
          <div>
            <div className="h-[2.5rem] gap-y-0 overflow-hidden sm:h-[3.5rem]">
              <motion.ul
                className="flex flex-col"
                initial={{
                  translateY: 0,
                }}
                animate={{
                  translateY: `-${currentCopyIdx * (height ?? 0)}px`,
                }}
                transition={
                  currentCopyIdx === 0
                    ? { duration: 0 }
                    : { duration: 0.18, ease: 'easeInOut' }
                }
              >
                {blocksToAnimate.map(([text, color], idx) => (
                  <h2
                    key={idx}
                    className={`font-psans text-3xl font-semibold leading-tight ${color} sm:text-4xl`}
                    ref={header}
                  >
                    {text}
                  </h2>
                ))}
              </motion.ul>
            </div>
            <h1 className="font-psans text-3xl font-semibold leading-tight text-rich-black sm:text-4xl">
              Instant Everything
            </h1>
          </div>
          <div className="space-y-3">
            <Link
              href="/start"
              className="inline-flex items-center space-x-2 rounded-full bg-rich-black px-8 py-3 font-psans text-base font-semibold text-clinical-white transition-colors hover:bg-gray-700"
            >
              Browse Services{' '}
              <FontAwesomeIcon
                icon={faCircleArrowRight}
                className="ml-2"
                size="lg"
              />
            </Link>
            <ProductReviewVariant2 />
          </div>
        </div>
        <div className="col-span-1 hidden md:block">
          <div className="relative w-full max-w-none overflow-visible">
            <Image
              src={landingPageHero}
              alt=""
              className="relative z-10 w-full object-contain"
              placeholder="empty"
            />
          </div>
        </div>
      </div>
    </Container>
  )
}
